import {useSearchParams} from "react-router-dom";

const DEFAULT_TITLE = "Inventory Hub";
const PREFIX = "IH";

export const PageTitle = ({title}) => {
	const [searchParams] = useSearchParams();

	const operator = searchParams.get("operator");

	if (!title && !operator) {
		return <title>{DEFAULT_TITLE}</title>;
	}

	const parts = [PREFIX];
	if (title) parts.push(title);
	if (operator) parts.push(operator);

	const displayTitle = parts.join(" ");

	return <title>{displayTitle}</title>;
};
